<template lang="pug">
    v-radio-group.c-form(
        v-model="period"
        row
    )
        v-radio.period.mr-3(
            v-for="(item, key) in $t('statistics.periods')"
            :key="key"
            :label="item.label"
            :value="item.value"
        )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions } from 'vuex';
    import VueTypes from 'vue-types';

    export default {
        computed: {
            ...mapFields('statistics', ['period'])
        },
        props: {
            id: VueTypes.string.def('')
        },
        watch: {
            period(val) {
                if (val === 'range') return;
                this.updateRange(this.id);
            }
        },
        methods: {
            ...mapActions('statistics', ['updateRange'])
        }
    };
</script>

<style lang="stylus" scoped>
    @media (max-width: 640px)
        .period
            width: 172px
</style>
